import { NAV_LINKS, BOOKING_PATH, LINKEDIN_URL } from "@/lib/site";
import { ArrowUpRight, Linkedin } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { trackClick } from "@/lib/track";

export const Footer = () => {
  const { t } = useLang();
  const f = t.footer;
  return (
    <footer className="relative border-t border-[var(--line)] pt-14 pb-10" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5">
        <div className="grid md:grid-cols-[1.4fr_1fr_1fr] gap-10">
          <div>
            <div className="flex items-center gap-3">
              <span className="grid place-items-center h-9 w-9 rounded-lg panel font-display font-bold text-sm text-white">RA</span>
              <div className="flex flex-col leading-none">
                <span className="font-display font-semibold text-white text-sm">
                  ReverseAI<span className="text-[var(--green)]">.dk</span>
                </span>
                <span className="font-mono text-[10px] uppercase tracking-[0.16em] text-[var(--muted-2)]">{f.role}</span>
              </div>
            </div>
            <p className="mt-5 text-sm text-muted max-w-sm leading-relaxed" data-testid="footer-tagline">{f.tagline}</p>
            <a href="https://reverseai.dk" className="mt-4 inline-block font-mono text-xs text-[var(--blue-bright)] hover:text-white transition-colors" data-testid="footer-domain">
              reverseai.dk
            </a>
            <div className="mt-5">
              <a
                href={LINKEDIN_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="ReverseAI.dk på LinkedIn"
                className="inline-flex items-center justify-center h-9 w-9 rounded-lg border border-[var(--line)] text-muted hover:text-white hover:border-[var(--blue-bright)] transition-colors"
                data-testid="footer-linkedin"
              >
                <Linkedin size={17} />
              </a>
            </div>
          </div>

          <div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-[var(--muted-2)] mb-4">{f.navHeading}</div>
            <ul className="space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-muted hover:text-white transition-colors" data-testid={`footer-nav-${l.key}`}>{t.nav[l.key]}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-[var(--muted-2)] mb-4">{f.getStarted}</div>
            <a href={`${BOOKING_PATH}?src=footer`} onClick={() => trackClick("book_time")} className="btn-primary !py-2.5 !px-4 text-sm" data-testid="footer-book-btn">
              {f.book} <ArrowUpRight size={15} />
            </a>
            <a href="#kontakt" onClick={() => trackClick("contact")} className="inline-flex items-center gap-1 mt-4 text-sm text-muted hover:text-white transition-colors" data-testid="footer-contact-link">{f.writeToMe} <ArrowUpRight size={14} /></a>
          </div>
        </div>

        <div className="divider-line my-10" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[var(--muted-2)] font-mono">
          <span>© {new Date().getFullYear()} ReverseAI.dk</span>
          <span>reverseai.dk · {f.role}</span>
        </div>
      </div>
    </footer>
  );
};
